import { useEffect } from "react";
import { connect } from "react-redux";
import Navbar from "components/Navbar";
import Hero from "components/landingPage/Hero";
import Product from "components/landingPage/Product";
import Footer from "components/Footer";

import { fetchData } from "store/actions/dataAction";

function LandingPage({ data, fetchData }) {
  useEffect(() => {
    document.title = "Shoesnarian | Home";

    if (!data.category) fetchData(`/category`, "category");

    if (!data.product) fetchData(`/product`, "product");
  }, [fetchData, data]);

  return (
    <div>
      <Navbar />
      <Hero />
      <Product category={data.category} product={data.product} />
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

export default connect(mapStateToProps, { fetchData })(LandingPage);
